import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://stxmyoxorcftzopihphh.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN0eG15b3hvcmNmdHpvcGlocGhoIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzMyMDc0NDEsImV4cCI6MTk4ODc4MzQ0MX0.RedgGPJ3xO4t96_0aojrHRYVz0opEeyT1z2Stbu6bl4";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
